<template>
  <a-modal v-model="visible" title="" onOk="handleOk" width="750px" @cancel="$emit('close')">
    <template slot="footer">
      <a-button key="back" @click="$emit('close')">Cancel</a-button>
      <a-button
        key="submit"
        style="background-color:#20409a; color: #fff"
        :loading="loading"
      >
        schedule
      </a-button>
    </template>
    <div class="mt-4">
      <h4 class="font-weight-bolder text-left kova-text">
        Schedule a Call
      </h4>
      <p class="text-left">
        Lets discuss your project and introduce you to your dev team
      </p>
      <div class="row mt-4">
        <div class="col-1 text-right">
          <font-awesome-icon
            class="kova-text"
            style="font-size:20px"
            icon="circle"
          ></font-awesome-icon>
        </div>
        <div class="col">
          <p class="text-left">
            DevTeamSpace.Space.Stategy session Kovatek
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-1 text-right">
          <font-awesome-icon
            class="kova-text"
            style="font-size:20px"
            icon="comment-alt"
          ></font-awesome-icon>
        </div>
        <div class="col">
          <p class="text-left">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et.
          </p>
        </div>
      </div>
      <hr />
      <h4 class="font-weight-bolder text-left kova-text">
        Set Date and Time
      </h4>
      <div class="my-3">
        <span class="bg-light px-2 py-2 rounded font-weight-bolder">{{
          interviewDate | dateOnly
        }}</span>
        <span class="bg-light px-2 py-2 rounded font-weight-bolder ml-3">{{
          time | timeOnly
        }}</span>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div
            :style="{
              width: '300px',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
            }"
          >
            <a-calendar
              :fullscreen="false"
              @select="onSelect"
              @panelChange="onPanelChange"
            />
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="mt-4"></div>
          <a-time-picker use12Hours format="h:mm a" @change="getTime" />
          <div class="mt-3 mt-md-5">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span
                  ><a-icon
                    type="info-circle"
                    style="position:relative; bottom: 3px;font-size: 16px;"
                  />
                  Click to copy to artboard</span
                >
              </template>
              <span class="kova-id px-3 py-2 text-white font-weight-bolder"
                >Call ID: Kovatek.id.2245</span
              >
            </a-tooltip>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      time: Date.now(),
      date: Date.now(),
      interviewDate: Date.now(),
      loading: false,
      // time: Date.now(),
    };
  },
  props: {
    visible: Boolean,
  },
  methods: {
    onSelect(value) {
      this.date = value;
      this.interviewDate = value;
    },
    onPanelChange(value) {
      // console.log(value, mode);
      this.date = value;
      this.interviewDate = value;
    },
    getTime(time) {
      // console.log(time, timeString);
      this.time = time;
    },
  },
};
</script>
<style></style>
